/**
 * DATA LAYER (DL): ROLLERS (Arma la Imagen)
 * Communicates with the Rollers API endpoints.
 */

export const GetThemes = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/GetThemes`);
        if (!response.ok) throw new Error('Error al obtener temas');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const GetTheme = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/GetTheme/${id}`);
        if (!response.ok) throw new Error('Error al obtener tema');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const SaveTheme = async (data) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/SaveTheme`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Error al guardar tema');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const DeleteTheme = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/DeleteTheme/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error('Error al eliminar tema');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const GetConfig = async (targetScreenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/GetConfig/${targetScreenId}`);
        if (!response.ok) throw new Error('Error al obtener configuración');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const SaveConfig = async (data) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/SaveConfig`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Error al guardar configuración');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const ExecuteSpin = async (dataPayload) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/Spin`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataPayload)
        });
        if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            return { success: false, message: err.message || 'Error al ejecutar el giro' };
        }
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const PrepareScreen = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/PrepareScreen/${screenId}`, {
            method: 'POST'
        });
        if (!response.ok) throw new Error('Error al preparar la pantalla');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const GetScreens = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/GetScreens`);
        if (!response.ok) throw new Error('Error al obtener pantallas');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const AddScreen = async (data) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/AddScreen`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Error al crear pantalla');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const DeleteScreen = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/DeleteScreen/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error('Error al eliminar pantalla');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const IdentifyScreens = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/IdentifyScreens`, {
            method: 'POST'
        });
        if (!response.ok) throw new Error('Error al identificar pantallas');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const UploadMedia = async (formData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/UploadMedia`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error('Error al subir archivo');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const ShowCover = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/ShowCover/${screenId}`, {
            method: 'POST'
        });
        if (!response.ok) throw new Error('Error al mostrar portada');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const ToggleThanks = async (screenId, show) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/ToggleThanks/${screenId}/${show}`, {
            method: 'POST'
        });
        if (!response.ok) throw new Error('Error al alternar agradecimiento');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const StopReel = async (screenId, reelIndex) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Rollers/StopReel/${screenId}/${reelIndex}`, {
            method: 'POST'
        });
        if (!response.ok) throw new Error('Error al detener rodillo');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};
